export default __webpack_public_path__ + "static/media/bootcamp_white_text_logo.c3ec9cf3.svg";